module.exports = __webpack_public_path__ + "static/media/natural_product.cc050382.png";